// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"AIDriven_TheComp__ETIVX"};